import { render, staticRenderFns } from "./customerLogin.vue?vue&type=template&id=98acfdd8&scoped=true"
import script from "./customerLogin.vue?vue&type=script&lang=js"
export * from "./customerLogin.vue?vue&type=script&lang=js"
import style0 from "./customerLogin.vue?vue&type=style&index=0&id=98acfdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98acfdd8",
  null
  
)

export default component.exports